import { create } from "zustand";

export interface NotificationState {
  open: boolean;
  message: string;
  severity: "success" | "error" | "info" | "warning";
  show: (
    message: string,
    severity?: "success" | "error" | "info" | "warning"
  ) => void;
  close: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  open: false,
  message: "",
  severity: "success",
  show: (message, severity = "success") =>
    set({ open: true, message, severity }),
  close: () => set({ open: false }),
}));
